// Pasted from modelLevers
import React from "react";

// Common typographic styles used on this page
import styled from "tachyons-components";

// f4 font-size
// fw font-weight
// black-50 color
// mt margin-top
// lh line-height
// pa padding
export const Caption = styled("p")`
  f4 fw2 black-50 mt0 lh-copy pa3 mb0
`;

export const Subheader = styled("h3")`
  f3 lh-copy pa3 mt0
`;

export const Directions = styled("p")`
  f4 fw1 black-50 lh-copy pl4
`;

// ba: borders
export const ButtonRow = styled("div")`
  flex justify-end pa4"
`;
export const Button = styled("span")`
  f5 no-underline black bg-animate hover-bg-black hover-white inline-flex items-right pa3 ba border-box
  mr2 fw2
`;

export const ButtonLabel = styled("span")`
  f4 ml3 pr2
`;

// LearnMore
export const ExplanationHeader = styled("p")`
  f3 lh-copy pal3 mt1 mb1
`;

export const Explanation = styled("p")`
  f4 fw2 black-50 mt0 lh-copy pa3 mb0 mt0 measure-wide
`;

// LearnMoreCity
export const List = styled('ul')`
  list p10 measure-wide
`

export const ListItem = styled('li')`
  lh-copy pv3 ba bl-0 bt-0 br-0
`

export const SourceLink = styled("a")`
  fw7 dib pa2 no-underline bg-animate bg-white hover-bg-light-blue black
`;



// WEBPACK FOOTER //
// ./src/pages/modelCity/panes/common.js